<template>
  <header
    class="source-sans border-bottom border-4 border-azul-medio imagen-fondo-header"
  >
    <b-container>
      <b-row>
        <!-- LOGO MINEDUC -->
        <b-col class="p-0 m-0 order-1 mt-auto">
          <div class="p-0 ml-auto mr-2 mr-lg-0 mb-2 text-right">
            <b-dropdown
              v-if="$route.name == 'Comprobantes'"
              variant="outline"
              toggle-class="btn-usuario p-0 rounded-0 pr-1 text-white gilmer d-none d-lg-block"
              menu-class="p-0"
              text="Cerrar sesión"
              right
            >
              <b-dropdown-item
                class="text-white btn-azul-oscuro-menu pr-2 py-2"
                href="#"
                @click.prevent="cerrarSesion"
              >
                Cerrar sesión
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
        <!-- LOGO MINEDUC fin -->

        <!--<b-col class="text-right">
          <img
            src="https://admisionlogos.s3.amazonaws.com/recuperar-comprobante-vue/logotop-fondo-azul.png"
            width="220"
            class="img-fluid d-block mt-1 mb-2 mt-lg-2"
            alt=""
          />
           -->
        <b-col class="text-right">
          <img
            src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/Logo6.png"
            width="220"
            class="img-fluid d-block mt-1 mb-2 mt-lg-2"
            alt=""
          />
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>
<script>
export default {
  methods: {
    cerrarSesion() {
      this.$router.replace({ name: "Inicio" });
    }
  }
};
</script>
<style scoped>
.imagen-fondo-header {
  background-image: url("https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/fondo-header.jpg");
  background-color: #182c66;
  background-repeat: no-repeat;
  background-position: right top;
}
</style>



// WEBPACK FOOTER //
// src/components/wrapper/Header.vue